export interface WorkItemsViewPreferenceScopeOptions {
  templateKey?: string | null;
  moduleContext?: string | null;
  boardKey?: string | null;
  itemType?: string | null;
  financeMode?: boolean;
  dataGridStyleVariant?: string | null;
}

function sanitizeScopePart(value: string): string {
  return value.trim().replace(/[^a-zA-Z0-9_-]+/g, '-');
}

export function buildWorkItemsViewPreferenceScopeKey(options: WorkItemsViewPreferenceScopeOptions): string {
  const {
    templateKey,
    moduleContext,
    boardKey,
    itemType,
    financeMode = false,
    dataGridStyleVariant,
  } = options;

  if (boardKey && boardKey.trim().length > 0) {
    return sanitizeScopePart(boardKey);
  }

  const rawScope = [
    templateKey || moduleContext || 'work-items',
    itemType || 'mixed',
    financeMode ? 'finance' : 'standard',
    dataGridStyleVariant || 'default',
  ]
    .filter(Boolean)
    .map((value) => sanitizeScopePart(String(value)));

  return `work-items-view__${rawScope.join('__')}`;
}
